import type { Plugin } from "chart.js";

export interface ForecastZoneOptions {
  startValue?: number;
  label?: string;
  fillColor?: string;
  labelColor?: string;
}

export const FORECAST_ZONE_PLUGIN_ID = "forecastZone";

const ZONE_OPACITY = 0.04;
const DIVIDER_OPACITY = 0.7;

export const forecastZonePlugin: Plugin<"line", ForecastZoneOptions> = {
  id: FORECAST_ZONE_PLUGIN_ID,
  beforeDatasetsDraw: (chart, _arguments, options) => {
    const horizontalScale = chart.scales.x;
    if (options.startValue === undefined || !horizontalScale) return;
    const { top, bottom, right } = chart.chartArea;
    const zoneLeft = Math.max(horizontalScale.getPixelForValue(options.startValue), chart.chartArea.left);
    if (zoneLeft >= right) return;
    const context = chart.ctx;
    context.save();
    context.globalAlpha = ZONE_OPACITY;
    context.fillStyle = options.fillColor ?? "#80ed40";
    context.fillRect(zoneLeft, top, right - zoneLeft, bottom - top);
    context.globalAlpha = DIVIDER_OPACITY;
    context.strokeStyle = options.labelColor ?? "#d1d6cc";
    context.lineWidth = 1;
    context.setLineDash([4, 4]);
    context.beginPath();
    context.moveTo(zoneLeft, top);
    context.lineTo(zoneLeft, bottom);
    context.stroke();
    context.setLineDash([]);
    context.globalAlpha = 1;
    if (options.label) {
      context.fillStyle = options.labelColor ?? "#d1d6cc";
      context.font = "11px sans-serif";
      context.textBaseline = "top";
      context.fillText(options.label, zoneLeft + 6, top + 4);
    }
    context.restore();
  },
};
